export const dynamicViewportHeight = (property = 'height') => ({
  [property]: '100vh',
  [`@supports (${property}: 100dvh)`]: {
    [property]: '100dvh',
  },
});
